// extracted by mini-css-extract-plugin
export default {"spacing":"qJtse","spacing_flex":"lw2cd","spacing_flex-column":"_xWR6","spacing_flexColumn":"_xWR6","appear-from-above":"JjQcQ","appearFromAbove":"JjQcQ"};